export default [
  { value: '90', text: 'under 100 Lbs' },
  { value: '110', text: '100-119 Lbs' },
  { value: '130', text: '120-139 Lbs' },
  { value: '150', text: '140-159 Lbs' },
  { value: '170', text: '160-179 Lbs' },
  { value: '190', text: '180-199 Lbs' },
  { value: '210', text: '200-219 Lbs' },
  { value: '230', text: '220-239 Lbs' },
  { value: '250', text: '240-259 Lbs' },
  { value: '270', text: '260-279 Lbs' },
  { value: '290', text: '280-299 Lbs' },
  { value: '300', text: '300+ Lbs' }
]
